export default "__VITE_ASSET__CJWTidwe__"